import React, { Fragment } from "react";
import Skeleton from "@material-ui/lab/Skeleton";

function PageTitle({ title, loading, className }) {
  return (
    <Fragment>
      {loading ? (
        <Skeleton variant="text" animation="wave" width={100} />
      ) : (
        <div className={`pageTitle ${className ? className : ''}`}>
          <span className="dot" />
          <p className="mx-2">{title}</p>
        </div>
      )}
    </Fragment>
  );
}

export default PageTitle;
